module.exports = __webpack_public_path__ + "media/images/brief-success/success-envelope-0f5c98ed104addeaff892dbdde89f154.svg";